export const makeFilterQualityEdge = (field, sign, val) => {
  return [sign, field, val];
};

export const makeFilterQualityMiddle = (field, min, max) => {
  return [
    "any",
    ["<=", field, min],
    [">", field, max]
  ];
};
